import React from 'react';
import { ToastContainer } from 'react-toastify';
import './NotificationToast.scss';

const AUTO_CLOSE_TIMEOUT_MS = 3000;

export const NotificationToast: React.FC = React.memo(() => (
  <ToastContainer autoClose={AUTO_CLOSE_TIMEOUT_MS} closeButton={false} />
));
